/**
 * * Модель фильтра для поиска задач в очереди
 */
export default class GetTaskListRequestFilter  {
	/**
	 * * Поле поиска
	 */
	Search!: string;
	/**
	 * * Поиск по названию статуса
	 */
	SearchByStatusName: boolean = false;
	/**
	 * * Поиск в описании задачи
	 */
	SearchInDescription: boolean = false;
	/**
	 * * Статус задачи
	 */
	StatusId!: Array<number>;
	/**
	 * * Глобальные статусы задачи
	 */
	GlobalStatusIds!: Array<string>;
	/**
	 * * Приоритет проекта
	 */
	PriorityId!: Array<number>;
	/**
	 * * Без приоритета
	 */
	WithoutPriorities?: boolean = false;
	/**
	 * * Список id исполнителей
	 */
	PerformerIds!: Array<number>;
	/**
	 * * Список id наблюдателей
	 */
	ObserverIds!: Array<number>;
	/**
	 * * Список авторов
	 */
	AuthorIds!: Array<number>;
	/**
	 * * Список сложностей
	 */
	DifficultyIds!: Array<string>;
	/**
	 * * Список тегов
	 */
	TagIds!: Array<number>;
	/**
	 * * Без тегов
	 */
	WithoutTags?: boolean = false;
	/**
	 * * Поиск автора или исполнителя по AuthorIds и PerformerIds
	 */
	IsAuthorOrPerformer: boolean = false;
	/**
	 * * Оценка по времени от
	 */
	EstimateFrom?: number;
	/**
	 * * Оценка по времени до
	 */
	EstimateTo?: number;
	/**
	 * * Затреченное время от
	 */
	WorkTimeFrom?: number;
	/**
	 * * Затраченное время до
	 */
	WorkTimeTo?: number;
	/**
	 * * Дата начала дедлайна
	 */
	DateExecutEnd?: Date;
	/**
	 * * Дата конца Дедлайна
	 */
	DateExecutStart?: Date;
	/**
	 * * Список id типов задач
	 */
	TypeIds!: Array<string>;
	constructor(obj?: Partial<GetTaskListRequestFilter>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
